export default __webpack_public_path__ + "images/favicon-96x96.png";